module.exports = require("core-js-pure/stable/instance/index-of");